import * as api from '../api';

export const checkIfPhone = (phone, setCheckPhone) => dispatch => {
  api.checkIfPhoneExist(phone, setCheckPhone).then(emailExist => {
    return emailExist;
  })
}